import useAppModal from 'hooks/useAppModal';
import { Integration } from 'models/InternalIntegrationSetting';
import ShareGuestInfoModal from './ShareGuestInfoModal';

const SHARE_GUEST_INFO_MODAL_ID = 'integration-share-guest-info-modal';

const useShareGuestInfoModal = () => {
  const { openModal } = useAppModal();

  const openShareGuestInfoModal = ({
    integration,
    onConfirm,
  }: {
    integration: Integration;
    onConfirm: () => void;
  }) => {
    openModal({
      customContent: (
        <ShareGuestInfoModal
          integration={integration}
          onConfirm={onConfirm}
          modalId={SHARE_GUEST_INFO_MODAL_ID}
        />
      ),
      id: SHARE_GUEST_INFO_MODAL_ID,
      size: 'medium',
    });
  };

  return { openShareGuestInfoModal };
};

export default useShareGuestInfoModal;
